import { UserNotificationModel } from '@twrx-api-models';

export interface IUserNotificationsState {
	items:       UserNotificationModel[];
	totalCount:  number;
	unreadCount: number;
	loading:     boolean;
}

export const initialUserNotificationsState: IUserNotificationsState = {
	items:       [],
	totalCount:  0,
	unreadCount: 0,
	loading:     false
};
